import { ServerAPI } from '../GeneralFunction';

const AdLookupAPI = {
	getwebhooksitelist: (data) => {
		let url = "get_webhook_site_list";
		const requestOptions = ServerAPI(url, 'POST', data);
		return fetch(process.env.REACT_APP_BACKEND_API_BASE_URL+url, requestOptions);
	},
	getlookupattributionresult: (data) => {
		let url = "get_lookup_attribution_result";
		const requestOptions = ServerAPI(url, 'POST', data);
		return fetch(process.env.REACT_APP_BACKEND_API_BASE_URL+url, requestOptions);
	},
	generatemagiclink: (data) => {
		let url = "generate_magic_link";
		const requestOptions = ServerAPI(url, 'POST', data);
		return fetch(process.env.REACT_APP_BACKEND_API_BASE_URL+url, requestOptions);
	},
	decodemagiclink: (data) => {
		let url = "decode_magic_link";
		const requestOptions = ServerAPI(url, 'POST', data);
		return fetch(process.env.REACT_APP_BACKEND_API_BASE_URL+url, requestOptions);
	},
	getattributionadspreviewdata: (data) => {
		let url = "get_attribution_ads_preview_data";
		const requestOptions = ServerAPI(url, 'POST', data);
		return fetch(process.env.REACT_APP_BACKEND_API_BASE_URL+url, requestOptions);
	}
};

export default AdLookupAPI;